module.exports = __webpack_public_path__ + "img/check.d55ace9c.svg";